export const loadCachedScript = (url: string, callback?: () => void) => {
    // Create a new script element
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    // Set up a callback to execute once the script is loaded
    script.onload = callback;

    // Append the script element to the document body
    document.body.appendChild(script);
}
